import { KeyDict } from '@/types'
import { LayoutBox, LayoutBoxField } from '@/types/layouts'
import { computed, ComputedRef } from '@vue/composition-api'
import { SceneContent } from '@/types/sceneContent'
import { getGlobalPresetsBoxIds } from '../utils/globalPresets'
import { Cast } from '@/modules/casts/classes'

type BoxPlaceholdersMap = {
  back: KeyDict<LayoutBox>,
  front: KeyDict<LayoutBox>
}

const useSceneLayouts = (cast: ComputedRef<Cast|null>, sceneId?: ComputedRef<string|null>) => {
  const currentScene = computed(() => cast.value?.scenesWithPresets[sceneId?.value ?? ''] ?? null)

  const sceneLayout = computed(() => {
    if (!sceneId?.value) return null
    return cast.value?.scenes[sceneId.value]?.scene_layout ?? null
  })
  const sceneWithPresetsLayout = computed(() => {
    if (!sceneId?.value) return null
    return cast.value?.scenesWithPresets[sceneId.value]?.scene_layout ?? null
  })

  const boxPlaceholders = computed<BoxPlaceholdersMap>(() => {
    const map: BoxPlaceholdersMap = { back: {}, front: {} }
    const currentSceneBoxes: LayoutBox[] = Object.values(currentScene.value?.scene_layout.boxes ?? {})
    const currentSceneContents: SceneContent[] = Object.values(currentScene.value?.contents ?? {})
    const globalPresetBoxIds = getGlobalPresetsBoxIds(Object.values(cast.value?.scenePresets ?? {}))
    for (const box of currentSceneBoxes) {
      const hasContent = currentSceneContents.some((content) => content.box === box.id)
      if (hasContent) continue
      const isGlobalBox = globalPresetBoxIds.includes(box.id)
      if (isGlobalBox) continue
      if (box.field === LayoutBoxField.BACK) map.back[box.id] = box
      else map.front[box.id] = box
    }
    return map
  })

  return {
    boxPlaceholders,
    sceneLayout,
    sceneWithPresetsLayout
  }
}

export default useSceneLayouts
